import type { SelectedTarget } from "./selectedTarget";

export const CHAT_BRIDGE_EVENT = "workspace:chat-message";
export const CHAT_BRIDGE_ACTIVE_KEY = "__agentmeChatBridgeActive";
export const CHAT_BRIDGE_QUEUE_KEY = "__agentmePendingChatBridgeMessages";

export interface ChatBridgeContext extends Record<string, unknown> {
  selectedTarget?: SelectedTarget;
}

export interface BridgeMessage {
  id: string;
  text: string;
  context?: ChatBridgeContext;
}
